// Example starter JavaScript for disabling form submissions if there are invalid fields
// https://getbootstrap.com/docs/4.0/components/forms/#custom-styles
(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        const forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        const validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

$(function(){
    $("input[type=checkbox][readonly='readonly']").click(function () {
        return false;
    });
    $("input[type=radio][readonly='readonly']").click(function () {
        return false;
    });
    $("select[readonly='readonly'] option:not(:selected)").remove();

    //Ordem de execução de listeners é determinado pela especificidade do seletor. Ele deve ser o menos especifico possível para poder ser bloqueado por outros listeners.
    $('form').submit(function(){
        $(this).find(':submit.btn').html(
            '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>' +
            ' Aguarde...'
        ).attr('disabled','disabled');
    });

    maskElements();
});
